import { ROUTE_PATH, OperationType, USER_TYPE } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class TravelReimbursementGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        // super(
        //     'Travel Reimbursement',
        //     ROUTE_PATH.travelReimbursement,
        //     ROUTE_PATH.addTravelReimbursement,
        //     false,
        //     false,  //for edit delete
        //     8,
        //     false,
        //     false,
        //     ['assignment_name'],
        //     true,
        //     [],
        //     { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
        //     false,
        //     { evalKey: 'travelDoc', evalParam: [null], decisiveParam: false },
        //     false,
        //     false,
        //     false,
        //     null,
        //     { evalKey: 'isApproved', evalParam: ['1'], decisiveParam: false },
        //     false,
        //     null,
        //     {
        //         isPreview: false,
        //         isPreviewType: 'VIDEO',
        //         isEnvUrl: false,
        //         linkKey: ['filePath'],
        //         previewName: ''
        //     },
        //     {
        //         isTabSwitch: false,
        //         label: '',
        //         isChecked: false
        //     },
        //     true,
        //     true,
        //     false,
        //     []);

        super(
            'Travel Reimbursement',
            ROUTE_PATH.travelReimbursement,
            ROUTE_PATH.addTravelReimbursement,
            false,
            false,
            8,
            false,
            false,
            ['assignment_name'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'travelDoc', evalParam: [''], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            []);

    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];   //type_name
        const assignment_name = new Headers('Assignment Name', 'assignment_name', false, true, 'text');
        const type_name = new Headers('Type Name', 'type_name', false, true, 'text');
        const travelStartDate = new Headers('Upload Start Date', 'docStartDate', false, true, 'text');
        const travelEndDate = new Headers('Upload End Date', 'docEndDate', false, true, 'text');
        const travelDocUploadedDate = new Headers('Uploaded Date', 'uploadDate', false, true, 'text');
        const travelStudentStartDate = new Headers('Travel Start Date', 'startDate', false, true, 'text');
        const travelStudentEndDate = new Headers('Travel End Date', 'endDate', false, true, 'text');
        const travelTitleOrRemark = new Headers('Remark', 'travelTitleOrRemark', false, true, 'text');
        const preview = new Headers('Travel Document', 'travelDocument', false, true, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const edittravel = new Headers('', 'edittravel', false, false, 'edittravel');
        const travelDocument = new Headers('', 'travelDocument', false, true, 'travelDocument');
        headers.push(assignment_name);
        headers.push(type_name);
        headers.push(edittravel);
        headers.push(travelStartDate);
        headers.push(travelEndDate);
        headers.push(preview);
        // headers.push(travelDocument);
        headers.push(travelDocUploadedDate);
        headers.push(travelStudentStartDate);
        headers.push(travelStudentEndDate);
        headers.push(travelTitleOrRemark);
        return headers;
    }

    getApprovalStatus() {
        const userRole = JSON.parse(localStorage.getItem('profile')).role;
        return userRole === USER_TYPE.admin;
    }
}

